import { render, staticRenderFns } from "./fastvaluedeal-countdown.vue?vue&type=template&id=2b7fd60e&scoped=true&"
import script from "./fastvaluedeal-countdown.vue?vue&type=script&lang=js&"
export * from "./fastvaluedeal-countdown.vue?vue&type=script&lang=js&"
import style0 from "./fastvaluedeal-countdown.vue?vue&type=style&index=0&id=2b7fd60e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7fd60e",
  null
  
)

export default component.exports